/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const ContactForm = {
	init: function() {
		if ($('.contact-form').length === 0) {
			return;
		}
		this.onFormSubmit();
	},


	onFormSubmit: function() {
		$('.wpcf7-form').on('submit', function() {
			$('.wpcf7-submit').attr('disabled', true);
		});

		$('.wpcf7-form').on('DOMNodeInserted', function(e) {
			if (e.target.className === 'wpcf7-response-output') {
				$('.wpcf7-submit').attr('disabled', false);
			}
		});
	},

};

export default ContactForm;
